import type { IconData } from '@stacksjs/iconify-core'

export const webGrid: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2 13h12v9h2V2h-2v9H2z\" opacity=\".25\"/><path fill=\"currentColor\" d=\"M21 22h-5V2h5a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1\"/><path fill=\"currentColor\" d=\"M14 22H3a1 1 0 0 1-1-1v-8h12zm0-11H2V3a1 1 0 0 1 1-1h11z\" opacity=\".5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default webGrid
